import { makeStyles } from '@material-ui/core/styles'
import { MODEL_OPTIONS } from 'src/utils/constants/BuyPolicy'
import React from 'react'
import { AutoCompleteInput } from 'src/components/BuyPolicy/common/AutoCompleteInput'

const ModelSelector = ({ carDetails, handleChange }) => {
  const classes = useStyles()

  const handleModelSelector = (newValue) => {
    handleChange({
      model: newValue,
    })
  }
  const handleModelOptions = (option) => option?.name || ''

  return (
    <div className={classes.mainContainer}>
      <div className={classes.heading}>
        <span className={classes.headingContent}>Select the Model</span>
      </div>
      <div className={classes.inputContainer}>
        <div className={classes.inputContent}>
          <AutoCompleteInput
            optionList={MODEL_OPTIONS}
            handleOptionLabel={handleModelOptions}
            placeholder='Search'
            displayEmpty
            value={carDetails?.model}
            handleChange={(event, newValue) => handleModelSelector(newValue)}
            label='Model'
            nameLabel='model'
            className={classes.inputTextField}
          ></AutoCompleteInput>
        </div>
      </div>
    </div>
  )
}

export default ModelSelector

const useStyles = makeStyles({
  mainContainer: {
    padding: '10px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: '210px',
  },
  heading: {
    width: '100%',
    textAlign: 'center',
    marginTop: '-25px',
  },
  inputContainer: {
    display: 'flex',
    marginBottom: '20px',
    marginTop: '20px',
    width: '50%',
  },
  inputContent: {
    width: '100%',
  },
  formControl: {
    minWidth: 120,
    width: '100%',
  },
  inputTextField: {
    borderRadius: '5px !important',
    backgroundColor: 'white !important',
    fontSize: '12px !important',
    fontFamily: 'Roboto !important',
    width: '100%',
    '&  .MuiSvgIcon-root': {
      display: 'none',
    },
  },
  headingContent: {
    fontFamily: 'Roboto',
    fontSize: '16px',
    fontWeight: '400',
  },
})
